import React, { Component } from 'react';

import { ReactComponent as ExclamationCircle } from 'components/svg/icons/exclamation-circle.svg';
import { I18n } from 'components/translate';
import PropTypes from 'prop-types';

import './style.scss';
class StepTip extends Component {
  static propTypes = {
    contentLabel: PropTypes.string.isRequired
  };

  render() {
    const { contentLabel } = this.props;

    return (
      <div className="card-onboarding__step-tip">
        <ExclamationCircle className="card-onboarding__step-tip__icon" />
        <div className="card-onboarding__step-tip__content">
          <I18n html label={contentLabel} />
        </div>
      </div>
    );
  }
}

export default StepTip;
